/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Position_LabelInputs */

const vi_lot_position_label = /** @type {(inputs: Lot_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí lưu kho`)
};

/**

* @param {Lot_Position_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_position_label = /** @type {((inputs?: Lot_Position_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Position_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_position_label(inputs)
});